import { useOutletContext, Navigate, useNavigate } from "react-router";
import React from "react";
import routing from "routing";
import { ISession } from "types/session";
import { SessionTimeoutModal } from "components/ezpay/secure/common/session-timeout-modal";
import { useDispatch, useSelector } from "react-redux";
import { getPayableSession } from "selectors/payableSession";
import IamApi from "api/IamApi";
import { USER_LOGOUT } from "actions/userActions";
import { setPayableSession } from "actions/payableSessionActions";

export interface IProtectedRouteProps {
  element: JSX.Element;
}

export const ProtectedRoute = ({ element }: IProtectedRouteProps) => {
  const session = useOutletContext<ISession>();
  const payableSession = useSelector(getPayableSession);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const payableLogout = () => {
    navigate(routing.index(), { replace: true });
    IamApi.ezpay.logout();
    dispatch({ type: USER_LOGOUT });
    dispatch(setPayableSession(undefined));
  };

  if (payableSession) {
    return (
      <>
        {element}
        <SessionTimeoutModal logout={payableLogout} />
      </>
    );
  }

  if (session?.account) {
    return (
      <>
        {element}
        <SessionTimeoutModal logout={session.logout} />
      </>
    );
  }

  return <Navigate to={routing.index()} replace />;
};
